import { render, staticRenderFns } from "./WikiProcessReadOnly.vue?vue&type=template&id=5ac22470&scoped=true&"
import script from "./WikiProcessReadOnly.vue?vue&type=script&lang=js&"
export * from "./WikiProcessReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./WikiProcessReadOnly.vue?vue&type=style&index=0&id=5ac22470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac22470",
  null
  
)

export default component.exports